<template>
    <div class="cbd-message-layer" v-show="visible">
        <div  class="cbd-message-box">
            <div class="cbd-message-content">
                {{title}}
            </div>
            <footer>
                <div class="btn cancel-btn" @click="handleCancel">{{cancelTxt}}</div>
                <div class="btn confirm-btn" @click="handleConfirm">{{confirmTxt}}</div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    props: {
      title: {
        default: ''
      },
      cancelTxt: {
        default: '取消'
      },
      confirmTxt: {
        default: '确定'
      },
      cancelCallback: {
        default: null
      },
      confirmCallback: {
        default: null
      },
    },
    data () {
        return {
            visible: true
        }
    },
    methods: {
        show () {
            this.visible = true
        },
        hide () {
            this.visible = false
        },
        handleConfirm () {
            this.hide()
            typeof this.confirmCallback === 'function' && this.confirmCallback();
        },
        handleCancel () {
            this.hide()
            typeof this.cancelCallback === 'function' && this.cancelCallback();
        }
    }
}
</script>

<style lang="less" scoped>
    .cbd-message-layer {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,0.30);
        z-index: 10000;
    }
    .cbd-message-box {
        position: absolute;
        box-sizing: border-box;
        top: 370px;
        left: 50%;
        width: 580px;
        transform: translate(-50%);
        padding: 0;
        border-radius: 12px;
        font-size: 30px; /* px */
        font-size: 34px; /* px */
        color: #2B2B2B;
        background: #FFFFFF;
        text-align: center;
        .cbd-message-content {
            display: flex;
            min-height: 204px;
            padding-top: 16px; 
            justify-content: center;
            align-items: center;
        }
        footer {
            display: flex;
            font-size: 32px;
            color: #656565;
            text-align: center;
            border-top: 1px solid #F0F0F0;
            .btn {
                flex: 1;
                padding: 32px 0 40px 0;
            }
            .confirm-btn {
                border-left: 1px solid #F0F0F0; /* no */
                color: #FDBE00;
                font-weight: bold;
            }
        }
    }
</style>
